/**
 * Returns the formState without values which contain AvoidStoringValue param
 * @param {Array<object>} fields - array of screen field items
 * @param {object} formState - form state for current screen
 * @returns {(object|undefined)} formState
 */
export const getFilteredFormState = ({ fields, formState }) => {
  if (fields) {
    fields.forEach(field => {
      if (formState[field.name] && field.params.includes("AvoidStoringValue")) {
        delete formState[field.name];
      }
    });
  }

  return formState;
};
